import { useFlags } from 'launchdarkly-react-client-sdk';

import { UserPermissions } from 'types';

import getConfigValue from '../config';

import usePermissions from './usePermissions';

export function useMaintenancePortalLink() {
  const userPermissions = usePermissions();
  const isOrgAccountingAdmin = userPermissions.includes(UserPermissions.orgAccountingAdmin);
  const { serviceMaintenancePortalLink } = useFlags();
  const serviceAndMaintenanceBaseUrl = getConfigValue('VITE_APP_SERVICE_AND_MAINTENANCE_BASE_URL');
  const url = `${serviceAndMaintenanceBaseUrl}service-and-maintenance/work-orders`;

  return {
    isEnabled: Boolean(serviceMaintenancePortalLink && isOrgAccountingAdmin),
    url,
  };
}
